(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hol-quantity-offers"] && !Shopify.designMode) return;
  try {
    class HolQuantityOffers extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.form = this.closest('form');
      this.selector = this.form?.querySelector('quantity-selector-component');
      this.quantityInput = this.selector?.querySelector('input[name="quantity"]');
      if (!this.quantityInput) return;
      customElements.whenDefined('quantity-selector-component').then(() => {
        if (!this.isConnected || signal.aborted) return;
        this.addEventListener('change', this.selectOffer, { signal });
        this.form.addEventListener('quantity-selector:update', this.syncOffers, { signal });
        this.quantityInput.addEventListener('input', this.syncOffers, { signal });
        this.quantityInput.addEventListener('change', this.syncOffers, { signal });
        this.observer = new MutationObserver(this.syncOffers);
        this.observer.observe(this.quantityInput, { attributes: true, attributeFilter: ['max', 'min', 'step', 'disabled', 'data-cart-quantity'] });
        this.syncOffers();
        this.hidden = false;
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
    }
    selectOffer = (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      this.selector.setValue(radio.value);
      this.selector.updateButtonStates();
      this.selector.onQuantityChange();
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };
    syncOffers = () => {
      const quantity = Number(this.quantityInput.value);
      const min = Number(this.quantityInput.min) || 1;
      const step = Number(this.quantityInput.step) || 1;
      const max = this.selector.getEffectiveMax();
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const value = Number(radio.value);
        radio.disabled = this.quantityInput.disabled || value < min || (value - min) % step !== 0 || (max !== null && value > max);
        radio.checked = value === quantity;
      });
      const summary = this.querySelector('.hol-offers__note');
      const selected = this.querySelector('input[type="radio"]:checked');
      const text = selected?.closest('label')?.querySelector('.hol-offers__summary-source')?.textContent;
      if (summary) summary.textContent = text?.trim() || summary.dataset.defaultText;
    };
  }
  if (!customElements.get('hol-quantity-offers')) customElements.define('hol-quantity-offers', HolQuantityOffers);
  } catch(e) { console.error(e); }
})();

})();
